import {IncomingMaterialStatus} from '@domain/material-storage'
import {
  AccessTime,
  Check,
  Close,
  HelpOutline,
  PendingOutlined,
  SvgIconComponent
} from '@mui/icons-material'

export const IncomingMaterialStatusToIconMap: Record<IncomingMaterialStatus, SvgIconComponent> = {
  [IncomingMaterialStatus.Cancelled]: Close,
  [IncomingMaterialStatus.Delivered]: Check,
  [IncomingMaterialStatus.Overdue]: AccessTime,
  [IncomingMaterialStatus.Unknown]: HelpOutline,
  [IncomingMaterialStatus.Planned]: PendingOutlined
}
